import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTreeModule } from '@angular/material/tree';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { ExpertFilesModule } from '@techspert-io/expert-files';
import { ExpertsModule } from '@techspert-io/experts';
import {
  MvpExpertTypePipe,
  MvpExpertTypeTooltipPipe,
} from '@techspert-io/mvp-experts';
import { OpportunitiesModule } from '@techspert-io/opportunities';
import { SurveysModule } from '@techspert-io/surveys';
import { NgxFileDropModule } from 'ngx-file-drop';
import { BtxSharedModule } from '../../../../shared/btx-shared.module';
import { MaterialModule } from '../../../../shared/patterns/material-module';
import { ExpertCloneDirective } from './expert-clone/expert-clone.directive';
import { OpportunityActionsMenuComponent } from './opportunity-actions-menu/opportunity-actions-menu.component';
import { AvailabilityBoxComponent } from './opportunity-expert-list/expert/availability-box/availability-box.component';
import { ComplianceTrainingBoxComponent } from './opportunity-expert-list/expert/compliance-training-box/compliance-training-box.component';
import { ContactInfoBoxComponent } from './opportunity-expert-list/expert/contact-info-box/contact-info-box.component';
import { CountryBoxComponent } from './opportunity-expert-list/expert/country-box/country-box.component';
import { ExpertComponent } from './opportunity-expert-list/expert/expert.component';
import { ScheduledBoxReminderComponent } from './opportunity-expert-list/expert/scheduled-box/scheduled-box-reminder/scheduled-box-reminder.component';
import { ScheduledBoxComponent } from './opportunity-expert-list/expert/scheduled-box/scheduled-box.component';
import { ScreenerBoxComponent } from './opportunity-expert-list/expert/screener-box/screener-box.component';
import { OpportunityExpertListComponent } from './opportunity-expert-list/opportunity-expert-list.component';
import { OpportunityResultsComponent } from './opportunity-results.component';
import { OpportunitySearchSelectDialogComponent } from './opportunity-search-select-dialog/opportunity-search-select-dialog.component';
import { OpportunityTopBarComponent } from './opportunity-top-bar/opportunity-top-bar.component';
import { ExpertRespondedDetailComponent } from './responded-dialog/expert-responded-detail/expert-responded-detail.component';
import { RespondedDialogComponent } from './responded-dialog/responded-dialog.component';
import { SolicitationModule } from './send-solicitation-dialog/solicitation.module';
import { OpportunityExpertsEffects } from './services/opportunity-experts.effects';

@NgModule({
  declarations: [
    OpportunityResultsComponent,
    OpportunityTopBarComponent,
    OpportunityExpertListComponent,
    ExpertComponent,
    ContactInfoBoxComponent,
    CountryBoxComponent,
    AvailabilityBoxComponent,
    ScheduledBoxComponent,
    ScheduledBoxReminderComponent,
    ComplianceTrainingBoxComponent,
    RespondedDialogComponent,
    ExpertRespondedDetailComponent,
    ExpertCloneDirective,
    OpportunityActionsMenuComponent,
    ScreenerBoxComponent,
    OpportunitySearchSelectDialogComponent,
  ],
  imports: [
    BtxSharedModule,
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    SolicitationModule,
    MatTreeModule,
    MaterialModule,
    NgxFileDropModule,
    ExpertsModule,
    MvpExpertTypePipe,
    MvpExpertTypeTooltipPipe,
    SurveysModule,
    ExpertFilesModule,
    OpportunitiesModule,
    EffectsModule.forFeature(OpportunityExpertsEffects),
  ],
  exports: [
    OpportunityResultsComponent,
    OpportunityTopBarComponent,
    OpportunityExpertListComponent,
    ExpertComponent,
    ContactInfoBoxComponent,
    CountryBoxComponent,
    ScheduledBoxComponent,
    ScheduledBoxReminderComponent,
    AvailabilityBoxComponent,
    ComplianceTrainingBoxComponent,
  ],
})
export class OpportunityModule {}
